


import React from 'react';

import ReactDOM from 'react-dom';
 
import { Button,Drawer } from '@jd/find-react';
 
import KeeVue from '../base/KeeVue.js'
 
 



export default class FsJsonConfig extends KeeVue {
  constructor(props) {
         super(props);
// this.getRandString(),
			this.state =  {
				id: "sssssssssssss",
				topWin: {
				},
				rightMenu: { },
				rightDetail: { },
				bottomDetail: { },
				active:false,
				content:null,
				 
			};

}

componentDidMount(){
			var that = this;
			this.registComponent(); 
			//this.initJsonEditor();
			 
			this.onEvent("showJsonRightConfig",this.showComponentInfo);
			this.onEvent("updateComponentProperty", this.setActiveComponent);
			
			this.onEvent("selectComponent", (item)=>{this.setActiveComponent(null,item)});
		 
		}
		setActiveComponent=(event,component)=>{
			// 快速定位到这个组件的json位置
		
			
			if(this.jsonEditor&&component)
			{
				this.jsonEditor.find(component.id, {
					backwards: false,
					wrap: false,
					caseSensitive: false,
					wholeWord: false,
					regExp: false
				});
				this.jsonEditor.findNext();
				this.jsonEditor.findPrevious();
			}
			
			
		}
		initJsonEditor=()=> {
		
			var that = this;
			this.jsonEditor = window.ace.edit(""+this.state.id);
			this.jsonEditor.setTheme("ace/theme/chrome");
			this.jsonEditor.session.setMode("ace/mode/json");
			this.jsonEditor.setFontSize(14);
			this.jsonEditor.setReadOnly(false);
			 this.jsonEditor.setOption("wrap", "free")
			window.ace.require("ace/ext/language_tools");
			this.jsonEditor.setOptions({
				enableBasicAutocompletion: true,
				enableSnippets: true,
				enableLiveAutocompletion: true
			});
			 
			this.jsonEditor.clearSelection();
				this.jsonEditor.on("change", (e)=> {
					console.log("edit change   .....")
					if(this.components) {
						
						var newComponents = this.jsonEditor.getValue();
						
					//	console.log(newComponents);
						
						try{
							if(newComponents)
							{
								newComponents = JSON.parse(newComponents);
								
								// 把相应的值设置到目标对象里面
								
								//this.setComponentArray(newComponents,this.components);
								
								// 让主画布区更新
								
								this.sendEvent("pageJsonValueChange",newComponents);
							}
							
							
						}
						catch(e)
						{
							console.log(e);
						}
					}
				})
		}
		
	 
		
		removeNotUserProperty=(componentArray)=>{
			for(var i=0;i<componentArray.length;i++)
			{
				delete componentArray[i].functions;
				delete componentArray[i].icon;
				delete componentArray[i].rect;
				delete componentArray[i].events;
				delete componentArray[i].isKeeShowBorder;
					
				delete componentArray[i].isSelected;
				delete componentArray[i].isAdding;
				delete componentArray[i].isMoving;
				delete componentArray[i].showChild;
				delete componentArray[i].children;
				delete componentArray[i].key;
				delete componentArray[i].createTime;
				delete componentArray[i].updateTime;
				delete componentArray[i].userId;
				delete componentArray[i].seq;
				delete componentArray[i].viewName;
				delete componentArray[i].checked;
				delete componentArray[i].showme;
				
				if(componentArray[i].style)
				{
					for(var p in  componentArray[i].style)
					{
						if(componentArray[i].style[p]==null||componentArray[i].style[p]==="")
						{
						//	console.log("shanchu :"+p);
							delete componentArray[i].style[p];
						}
					}
				} 
				if(componentArray[i].child)
				{
					this.removeNotUserProperty(componentArray[i].child);
				}
				// if(componentArray[i].children)
				// {
				// 	this.removeNotUserProperty(componentArray[i].children);
				// }
				
			}
		}
		
		showComponentInfo=(components)=> {
			// if(this.state.activeComponent ) {
			// 	console.log(JSON.stringify(this.state.activeComponent))
			// } else {
			// 	alert("请先选择一个组件");
			// }
			this.components = components;
			
			if( !this.jsonEditor){
				this.initJsonEditor();
			}
			
			 if( this.jsonEditor) {
			 	//{"row":26,"column":30}
			 	//alert(JSON.stringify(editor.selection.getCursor()));
				var syncComponents = JSON.parse(JSON.stringify( components));
				this.removeNotUserProperty(syncComponents);
				var fjs = window.js_beautify(JSON.stringify(syncComponents), 1, "\t");
			 	this.jsonEditor.setValue(fjs);
			 
			 	this.jsonEditor.clearSelection();
			 	this.jsonEditor.moveCursorTo(0,0);
			 
			 }
			 
			 
			this.state.showJsonRight=true;
			this.refresh();
		}
		

			 

  render(){
	  console.log("渲染drawer")
  return(
	
	<div style={{width:' 100%',height:' 100%'}} >
	<div  style={{  position:' absolute', top:' 58px', left:' 0px', bottom:' 0px', right:' 0px', background:' #FFFFFF', border:' 0px solid #CCCCCC',overflow:'hidden'}} >
	       <pre id={this.state.id} className={`ace_editor`} style={{height:'100%' }} >
	           <textarea className={`ace_text-input`} >
	           </textarea>
	       </pre>
	</div>

	</div>
  );}
 }


